// components/layout/BlitzPayFilters.jsx
import React from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  Tooltip,
  InputAdornment,
  Divider,
} from "@mui/material";
import {
  Search as SearchIcon,
  Download as DownloadIcon,
  FilterList as FilterListIcon,
} from "@mui/icons-material";

const BlitzPayFilters = ({ 
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onDownloadPDF,
  isMobile = false
}) => {
  return (
    <Box sx={{ px: 3, pt: 3, pb: 2 }}>

      <Grid container spacing={2} alignItems="center">
        {/* Search Bar - Takes more space */}
        <Grid item xs={12} md={isMobile ? 12 : 4}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search transactions..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                borderRadius: 2,
                bgcolor: 'background.default',
              } 
            }}
          />
        </Grid>

        {/* Status Filter */}
        <Grid item xs={12} sm={6} md={isMobile ? 6 : 2}>
          <TextField
            fullWidth
            size="small"
            select
            label="Status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                borderRadius: 2,
                bgcolor: 'background.default',
              } 
            }}
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="funded">Funded</option>
            <option value="paid">Paid</option>
            <option value="cancelled">Cancelled</option>
          </TextField>
        </Grid>

        {/* Date Filters */}
        <Grid item xs={12} sm={6} md={isMobile ? 6 : 2.25}>
          <TextField
            fullWidth
            size="small"
            type="date"
            label="Start Date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                borderRadius: 2,
                bgcolor: 'background.default',
              } 
            }}
          />
        </Grid>

        {!isMobile && (
          <>
            <Grid item xs={12} sm={6} md={2.25}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="End Date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ 
                  '& .MuiOutlinedInput-root': { 
                    borderRadius: 2,
                    bgcolor: 'background.default',
                  } 
                }}
              />
            </Grid>

            {/* Download Button */}
            <Grid item xs={12} sm={6} md={1.5}>
              <Tooltip title="Download Report">
                <IconButton
                  onClick={onDownloadPDF}
                  sx={{ 
                    border: '1px solid',
                    borderColor: 'divider',
                    color: 'primary.main',
                    width: '100%',
                    height: 40,
                    borderRadius: 2,
                    bgcolor: 'background.default',
                    '&:hover': {
                      bgcolor: 'primary.main',
                      color: 'white',
                      borderColor: 'primary.main',
                    }
                  }}
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
          </>
        )}
      </Grid>

    </Box>
  );
};

export default BlitzPayFilters;
